import { Component } from '@angular/core';

declare var jQuery:any;

@Component({
    selector: 'basic',
    templateUrl: 'basic.template.html'
})
export class basicComponent {}


// WEBPACK FOOTER //
// ./src/app/components/common/layouts/basic.component.ts